export default "__VITE_ASSET__ClPr$5jP__"